import main_bg_1 from './Images/main_bg_1.png'
import main_bg_2 from './Images/main_bg_2.png'
import toggel_bg from './Images/toggel_bg.png'
import check_box_on from './Images/check_box_on.png'
import tip_icon from './Images/tip_icon.png'
import Arms_Muscles_Base_color from './Images/Arms_Muscles_Base_color.jpg'
import Arms_Muscles_Roughness from './Images/Arms_Muscles_Roughness.jpg'
import Arms_Muscles_Normal_OpenGL from './Images/Arms_Muscles_Normal_OpenGL.jpg'
import Arms_Muscles_Metallic from './Images/Arms_Muscles_Metallic.jpg'
import Arms_Muscles_Emissive from './Images/Arms_Muscles_Emissive.jpg'
import Hands_Foot_Others_Base_color from './Images/Hands_Foot_Others_Base_color.png'
import Hands_Foot_Others_Metallic from './Images/Hands_Foot_Others_Metallic.png'
import Hands_Foot_Others_Normal_OpenGL from './Images/Hands_Foot_Others_Normal_OpenGL.png'
import Hands_Foot_Others_Roughness from './Images/Hands_Foot_Others_Roughness.png'
import Hands_Foot_Others_Emissive from './Images/Hands_Foot_Others_Emissive.png'
import backgroundImg from './Images/backgroundImg.png'
import language_korea from './Images/language_korea.png'
import language_uk from './Images/language_uk.png'
import tips1 from './Images/tips1.png'
import tips2 from './Images/tips2.png'


const images = {
       main_bg_1: main_bg_1,
       main_bg_2: main_bg_2,
       toggel_bg: toggel_bg,
       check_box_on: check_box_on,
       tip_icon: tip_icon,
       Arms_Muscles_Base_color: Arms_Muscles_Base_color,
       Arms_Muscles_Roughness: Arms_Muscles_Roughness,
       Arms_Muscles_Normal_OpenGL: Arms_Muscles_Normal_OpenGL,
       Arms_Muscles_Metallic: Arms_Muscles_Metallic,
       Arms_Muscles_Emissive: Arms_Muscles_Emissive,
       Hands_Foot_Others_Base_color: Hands_Foot_Others_Base_color,
       Hands_Foot_Others_Metallic: Hands_Foot_Others_Metallic,
       Hands_Foot_Others_Normal_OpenGL: Hands_Foot_Others_Normal_OpenGL,
       Hands_Foot_Others_Roughness: Hands_Foot_Others_Roughness,
       Hands_Foot_Others_Emissive: Hands_Foot_Others_Emissive,
       backgroundImg: backgroundImg,
       language_korea: language_korea,
       language_uk: language_uk,
       tips1: tips1,
       tips2: tips2,
}
export default images